import "../recharts/ChartSurfaceDark.css";
import "./Tabular.css";
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import { getCallAveragTasks } from "../../../actions/userActions/callAverageTasks";
import { getProducts } from "../../../actions/userActions/productAction";
import { getCallAveragTable } from "../../../actions/userActions/callAverageTab";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from 'dayjs';
import { IconButton, Tooltip as MaterialTooltip } from "@mui/material";
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import { Button, Menu, TextField } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import ToggleButton from '@mui/material/ToggleButton';
import BodyMediumRegular from "../../designSystem/BodyMediumRegular";
import MultiSelect from "../../designSystem/MultiSelect";
import BodySmallRegular from "../../designSystem/BodySmallRegular";
import { getSubOrdinates } from "../../../actions/userActions/tasks/taskAction";
import DynamicTable from "../../reuse_components/DynamicTable";
import { t } from "../../../locales/translate";
import LoadingOverlay from "../../loadingOverlay/LoadingOverlay";
export function Tabular({ onChangeCallTable }) {
    const dispatch = useDispatch();
    const [showDetailsForRow, setShowDetailsForRow] = useState({});
    const [anchorEl, setAnchorEl] = useState(null);
    const buttonLabels = {
        "today": "Today",
        "this week": "Week",
        "this month": "Month",
        "this year": "Year",
        "custom": `${t("custom")}`,
    };
    const open = Boolean(anchorEl);
    const [customDate, setCustomDate] = useState(false);
    const [formError, setFormError] = useState({});
    const [isLoadingProducts, setIsLoadingProducts] = useState(false);
    const [cachedProductOptions, setCachedProductOptions] = useState([]);
    const currentDate = moment();
    const [Filters, setFilters] = useState({
        productsIds: [],
        employeeIds: [],
        fromDate: moment(currentDate).subtract(7, "days").format("YYYY-MM-DD"),
        toDate: moment(currentDate).format("YYYY-MM-DD"),
    });
    const [selected, setSelected] = useState({
        productsIds: [],
        employeeIds: [],
        fromDate: moment(currentDate).subtract(7, "days").format("YYYY-MM-DD"),
        toDate: moment(currentDate).format("YYYY-MM-DD"),
    });
    const user = JSON.parse(localStorage.getItem("user"));
    const employeeId =
        user.result[0] !== undefined ? user.result[0].user.id : false
    const products = useSelector((state) => state.products_reducer.products);
    const employees = useSelector((state) => state.tasks_reducer.subOrdinates);

    useEffect(() => {
        if (products && products !== "isLoading" && products.result?.length) {
            setCachedProductOptions(
                products.result
                    .filter((product) => product.active)
                    .sort((a, b) => a.name.localeCompare(b.name))
                    .map((product) => ({
                        value: product.id,
                        label: product.name,
                    }))
            );
        }
    }, [products]);

    const callAvgTable = useSelector(
        (state) => state.call_avg_tab_reducer.callAvgTab
    );

    const handleDetails = (taskIDs, i) => {
        const body = {
            taskIDs: taskIDs
        };

        setShowDetailsForRow((prevState) => ({
            ...prevState,
            [i]: !prevState[i],
        }));

        dispatch(getCallAveragTasks(body));
    };

    const callAvgTasks = useSelector(
        (state) => state.call_avg_tasks_reducer.callAvgTasks
    );

    const productBody = {
        filter: {
            textSearch: "",
        },
        pageNumber: -1,
        pageSize: 0,
    };

    useEffect(() => {
        if (open) {
            setIsLoadingProducts(true);
            dispatch(getProducts(productBody))
                .then(() => {
                    dispatch(getSubOrdinates(employeeId, -1, 0, ""));
                })
                .catch(error => {
                    console.error("Error fetching data:", error);
                })
                .finally(() => {
                    setIsLoadingProducts(false);
                });
        }
    }, [open]);

    const handleApply = () => {
        if (validateForm()) {
            const body = {
                tableFilters: {
                    productsIds: Filters.productsIds ? Filters.productsIds : [0],
                    employeeIds: Filters.employeeIds ? Filters.employeeIds : [0],
                },
                startTime: Filters.fromDate ? Filters.fromDate : new Date().toISOString(),
                endTime: Filters.toDate ? Filters.toDate : new Date().toISOString(),
            };
            onChangeCallTable(body)
            dispatch(getCallAveragTable(body));
            handleClose();
        }
    };

    const handleReset = () => {
        setSelected({
            employeeIds: [],
            productsIds: [],
            fromDate: moment(currentDate).subtract(7, "days").format("YYYY-MM-DD"),
            toDate: moment(currentDate).format("YYYY-MM-DD"),
        });
        setFilters({
            employeeIds: [],
            productsIds: [],
            fromDate: moment(currentDate).subtract(7, "days").format("YYYY-MM-DD"),
            toDate: moment(currentDate).format("YYYY-MM-DD"),
        });
        setSelectedButton("this week");
    }

    const validateForm = () => {
        let errors = {};
        let isValid = true;
        if (!Filters.fromDate) {
            errors.fromDate = "From date is required.";
            isValid = false;
        }
        if (!Filters.toDate) {
            errors.toDate = "To date is required.";
            isValid = false;
        }

        setFormError(errors);
        return isValid;
    };

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const [selectedButton, setSelectedButton] = useState("this week");
  useEffect(() => {
    if (!open) return;

    const handleClickOutside = (event) => {
      const menuPaper = document.querySelector('.MuiMenu-paper, .MuiPopover-paper');
      
      // Don't close if clicking inside any MUI Paper (calendar, picker, dialog, etc.)
      const isInsideMuiPaper = event.target.closest('.MuiPaper-root') !== null;
      if (isInsideMuiPaper) return;
      
      if (menuPaper && !menuPaper.contains(event.target)) {
        handleClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside, true);
    return () => document.removeEventListener('mousedown', handleClickOutside, true);
  }, [open]);
    const handleToggleSelection = (event, newSelection) => {
        if (newSelection === "this week") {
            setCustomDate(false);
            const fromDate = moment().startOf("week").format("YYYY-MM-DD");
            const toDate = moment().endOf("week").format("YYYY-MM-DD");
            setSelected(prevValues => ({ ...prevValues, fromDate: fromDate, toDate: toDate }));
            setFilters(prevValues => ({ ...prevValues, fromDate: fromDate, toDate: toDate }));
        } else if (newSelection === "today") {
            setCustomDate(false);
            const fromDate = moment().startOf("day").toDate();
            const toDate = moment().endOf("day").toDate();
            setSelected(prevValues => ({ ...prevValues, fromDate: fromDate, toDate: toDate }));
            setFilters(prevValues => ({ ...prevValues, fromDate: fromDate, toDate: toDate }));
        } else if (newSelection === "yesterday") {
            setCustomDate(false);
            const fromDate = moment().subtract(1, "days").startOf("day").toDate();
            const toDate = moment().subtract(1, "days").endOf("day").toDate();
            setSelected(prevValues => ({ ...prevValues, fromDate: fromDate, toDate: toDate }));
            setFilters(prevValues => ({ ...prevValues, fromDate: fromDate, toDate: toDate }));
        }
        else if (newSelection === "last 30 days") {
            setCustomDate(false);
            const fromDate = moment().subtract(29, "days").toDate();
            const toDate = moment().endOf("day").toDate();
            setSelected(prevValues => ({ ...prevValues, fromDate: fromDate, toDate: toDate }));
            setFilters(prevValues => ({ ...prevValues, fromDate: fromDate, toDate: toDate }));
        } else if (newSelection === "this month") {
            setCustomDate(false);
            const fromDate = moment().startOf("month").toDate();
            const toDate = moment().endOf("month").toDate();
            setSelected(prevValues => ({ ...prevValues, fromDate: fromDate, toDate: toDate }));
            setFilters(prevValues => ({ ...prevValues, fromDate: fromDate, toDate: toDate }));
        } else if (newSelection === "last month") {
            setCustomDate(false);
            const fromDate = moment().subtract(1, "month").startOf("month").toDate();
            const toDate = moment().subtract(1, "month").endOf("month").toDate();
            setSelected(prevValues => ({ ...prevValues, fromDate: fromDate, toDate: toDate }));
            setFilters(prevValues => ({ ...prevValues, fromDate: fromDate, toDate: toDate }));
        } else if (newSelection === "this year") {
            setCustomDate(false);
            const fromDate = moment().startOf("year").toDate();
            const toDate = moment().endOf("year").toDate();
            setSelected(prevValues => ({ ...prevValues, fromDate: fromDate, toDate: toDate }));
            setFilters(prevValues => ({ ...prevValues, fromDate: fromDate, toDate: toDate }));
        } else if (newSelection === "custom") {
            setCustomDate(true);
            setSelected(prevValues => ({ ...prevValues, fromDate: "", toDate: "" }));
            setFilters(prevValues => ({ ...prevValues, fromDate: "", toDate: "" }));
        }

        setSelectedButton(newSelection);
    };

    const getProductOptions = () => {
        if (products && products !== "isLoading" && products.result?.length) {
            return products.result
                .filter((product) => product.active)
                .sort((a, b) => a.name.localeCompare(b.name))
                .map((product) => ({
                    value: product.id,
                    label: product.name,
                }));
        }
        return cachedProductOptions;
    };
    const productOptions = getProductOptions();
    const isProductFieldLoading = isLoadingProducts && productOptions.length === 0;

    const getEmployeeOptions = () => {
        return (
            employees &&
            employees !== "isLoading" &&
            employees.length !== 0 &&
            employees
                .sort((a, b) => {
                    const firstNameComparison = a.firstName.localeCompare(b.firstName);
                    return firstNameComparison !== 0
                        ? firstNameComparison
                        : a.lastName.localeCompare(b.lastName);
                })
                .map((employee) => ({
                    value: employee.id,
                    label: `${employee.firstName} ${employee.lastName}`,
                }))
        ) || [];
    };

    const handleProductsChange = (updatedValues) => {
        setSelected(prevValues => ({
            ...prevValues,
            productsIds: updatedValues,
        }));

        setFilters(prevValues => ({
            ...prevValues,
            productsIds: updatedValues,
        }));
    };

    const handleEmployeesChange = (selectedEmployees) => {
        setSelected(prevValues => ({
            ...prevValues,
            employeeIds: selectedEmployees,
        }));

        setFilters(prevValues => ({
            ...prevValues,
            employeeIds: selectedEmployees,
        }));
    };

    const handleFromDateChange = (date) => {
        const formattedDate = dayjs(date).startOf('day').toDate();
        setSelected(prevValues => ({
            ...prevValues,
            fromDate: formattedDate,
        }));
        setFilters(prevValues => ({
            ...prevValues,
            fromDate: formattedDate,
        }));
    };

    const handleToDateChange = (date) => {
        const formattedDate = dayjs(date).endOf('day').toDate();
        setSelected(prevValues => ({
            ...prevValues,
            toDate: formattedDate,
        }));
        setFilters(prevValues => ({
            ...prevValues,
            toDate: formattedDate,
        }));
    };

    // Prepare data for DynamicTable
    const tableData = callAvgTable && callAvgTable !== "isLoading" && callAvgTable.byTable
        ? callAvgTable.byTable
        : [];

    // Define columns for DynamicTable
    const columns = [
        {
            label: `${t("employee")}`,
            accessor: "employeeName",

        },
        {
            label: `${t("product")}`,
            accessor: "productName"
        },
        {
            label: `${t("calls")}`,
            accessor: "calls"
        },
        {
            label: `${t("date")}`,
            accessor: "dateTime",
            cell: (row) => moment(row.dateTime).format("MMM DD, YYYY")
        }
    ];

    return (
    <>
        <div className=" tabular-container overlay-wrapper" style={{
            backgroundColor: 'rgb(255, 255, 255)',
            gap: '24px',
            borderRadius: '16px',
            padding: '18px 20px',
            position: 'relative',
            maxHeight: '400px',
        }}>
            <LoadingOverlay isVisible={callAvgTable === "isLoading"} />
            <div className={callAvgTable === "isLoading" ? 'blur' : ''}>
                <div>
                    <div className="row">
                        <div className="col-10" style={{ display: "flex", alignItems: "center", gap: "8px", height: "20px" }}>
                            <BodyMediumRegular text={t("callAverageByTable")} style={{ fontWeight: 400 }} />
                        </div>
                        <div className="col-2 d-flex justify-content-end">
                            <MaterialTooltip title={t("applyFilters")} arrow enterDelay={500} placement="bottom">
                                <IconButton>
                                    <FilterAltOutlinedIcon onClick={handleClick} />
                                </IconButton>
                            </MaterialTooltip>
                            <Menu
                                id="basic-menu"
                                anchorEl={anchorEl}
                                open={open}
                                onClose={handleClose}
                                MenuListProps={{
                                    'aria-labelledby': 'basic-button',
                                }}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'left',
                                }}
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                PaperProps={{
                                    style: {
                                        width: "640px",
                                        borderRadius: "4px",
                                        background: "#FFFFFF",
                                        boxShadow: "0px 11px 15px -7px #00000033",
                                    },
                                }}
                            >
                                <div className="row" style={{
                                    padding: "16px 24px 16px 24px",
                                    justify: "space-between",
                                    display: "flex",
                                    gap: "24px"
                                }}>
                                    <div className="col-12 d-flex ml-2">
                                        <BodyMediumRegular text={t("applyFilters")} />
                                        <MaterialTooltip title="Close Filter" arrow>
                                            <CloseIcon style={{ marginLeft: "auto", cursor: "pointer" }} onClick={handleClose} />
                                        </MaterialTooltip>
                                    </div>
                                </div>
                                <div className="row" style={{
                                    gap: "24px",
                                    borderBottom: "1px solid #0000001F",
                                    padding: "24px 16px 24px 16px",
                                    alignItems: "center"
                                }}>
                                    <div className="row" style={{ gap: "16px" }}>
                                        <div className="col-12 d-flex justify-content-center align-items-center" style={{ height: "48px" }}>
                                            <ToggleButtonGroup
                                                exclusive
                                                value={selectedButton}
                                                onChange={handleToggleSelection}
                                                aria-label="button group"
                                                style={{
                                                    width: "100%",
                                                    height: "40px",
                                                    gap: "12px",
                                                    borderRadius: "6px",
                                                    padding: "4px 8px",
                                                    backgroundColor: "#f9fafb",
                                                    display: "flex",
                                                    justifyContent: "space-evenly",
                                                    alignItems: "center",
                                                }}
                                            >
                                                {["today", "this week", "this month", "this year", "custom"].map((value) => (
                                                    <ToggleButton
                                                        key={value}
                                                        value={value}
                                                        style={{
                                                            minWidth: "34px",
                                                            height: "34px",
                                                            padding: "4px 12px",
                                                            borderRadius: "6px",
                                                            textTransform: "none",
                                                            border: "none",
                                                            backgroundColor: selectedButton === value ? "#FFFFFF" : "inherit",
                                                            display: "flex",
                                                            justifyContent: "center",
                                                            alignItems: "center",
                                                        }}
                                                    >
                                                        <BodyMediumRegular text={buttonLabels[value]} />
                                                    </ToggleButton>
                                                ))}
                                            </ToggleButtonGroup>
                                        </div>
                                        <div className="col-12 d-flex" style={{ height: "56px" }}>
                                            <div className="col-6">
                                                <div style={{ marginBottom: "6px" }}>
                                                    <BodySmallRegular text={t("from")} />
                                                </div>
                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                    <DatePicker
                                                        valueType="date"
                                                        value={selected.fromDate && selected.fromDate.length != 0 ? dayjs(selected.fromDate) : null}
                                                        onChange={handleFromDateChange}
                                                        disabled={!customDate}
                                                        renderInput={(params) => <TextField fullWidth {...params} />}
                                                        sx={{
                                                            width: "100%",
                                                            "& .MuiOutlinedInput-root": {
                                                                height: "40px",
                                                                padding: "0",
                                                                boxSizing: "border-box",
                                                                backgroundColor: "transparent",
                                                                border: "1px solid #E0E0E0",
                                                                borderRadius: "60px",
                                                                "& .MuiOutlinedInput-notchedOutline": {
                                                                    border: "none",
                                                                },
                                                                "&:hover .MuiOutlinedInput-notchedOutline": {
                                                                    border: "none",
                                                                },
                                                                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                                                    border: "none",
                                                                },
                                                            },
                                                            "& .MuiInputBase-input": {
                                                                height: "32px",
                                                                padding: "0px 8px",
                                                                fontSize: "14px",
                                                            },
                                                            "& .MuiIconButton-root": {
                                                                padding: "20px",
                                                            },
                                                        }}
                                                    />
                                                </LocalizationProvider>
                                                {formError.fromDate && (
                                                    <span style={{ color: "red" }}>{formError.fromDate}</span>
                                                )}
                                            </div>
                                            <div className="col-6">
                                                <div style={{ marginBottom: "6px" }}>
                                                    <BodySmallRegular text={t("to")} />
                                                </div>
                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                    <DatePicker
                                                        valueType="date"
                                                        value={selected.toDate && selected.toDate.length != 0 ? dayjs(selected.toDate) : null}
                                                        onChange={handleToDateChange}
                                                        disabled={!customDate}
                                                        renderInput={(params) => <TextField fullWidth {...params} />}
                                                        sx={{
                                                            width: "100%",
                                                            "& .MuiOutlinedInput-root": {
                                                                height: "40px",
                                                                padding: "0",
                                                                boxSizing: "border-box",
                                                                backgroundColor: "transparent",
                                                                border: "1px solid #E0E0E0",
                                                                borderRadius: "60px",
                                                                "& .MuiOutlinedInput-notchedOutline": {
                                                                    border: "none",
                                                                },
                                                                "&:hover .MuiOutlinedInput-notchedOutline": {
                                                                    border: "none",
                                                                },
                                                                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                                                    border: "none",
                                                                },
                                                            },
                                                            "& .MuiInputBase-input": {
                                                                height: "32px",
                                                                padding: "0px 8px",
                                                                fontSize: "14px",
                                                            },
                                                            "& .MuiIconButton-root": {
                                                                padding: "20px",
                                                            },
                                                        }}
                                                    />
                                                </LocalizationProvider>
                                                {formError.toDate && (
                                                    <span style={{ color: "red" }}>{formError.toDate}</span>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row" style={{ gap: "16px" }}>
                                        <div className="col-12 d-flex" >
                                            <div className="col-6">
                                                <MultiSelect
                                                    isSearchable
                                                    onChange={handleProductsChange}
                                                    value={selected?.productsIds || []}
                                                    label={t("products")}
                                                    options={productOptions}
                                                    isLoading={isProductFieldLoading}
                                                    placeholder={isProductFieldLoading ? "Loading Products..." : t("select")}
                                                />
                                            </div>
                                            <div className="col-6">
                                                <MultiSelect
                                                    isSearchable
                                                    onChange={handleEmployeesChange}
                                                    value={selected?.employeeIds || []}
                                                    label={t("employee")}
                                                    options={getEmployeeOptions()}
                                                    isLoading={employees === "isLoading" || !employees || employees.length === 0}

                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row mr-4" style={{
                                    padding: "16px 24px 16px 24px",
                                    gap: "8px",
                                    display: "flex",
                                    justifyContent: "flex-end",
                                    alignItems: "center",
                                    flexWrap: "nowrap"
                                }}>
                                    <button
                                        type="submit"
                                        className="primary-button"
                                        disabled={false}
                                        onClick={handleApply}
                                        style={{ width: "78px", minWidth: "78px", maxWidth: "78px", flex: "0 0 78px" }}
                                    >
                                        <span className="button-content">
                                            <p className="button-text save">{t("apply")}</p>
                                        </span>
                                    </button>
                                    <button
                                        className="cancel-button"
                                        type="button"
                                        onClick={handleReset}
                                        style={{ width: "88px", minWidth: "88px", maxWidth: "88px", flex: "0 0 88px" }}
                                    >
                                        <span className="button-content">
                                            <p className="button-text">{t("reset")}</p>
                                        </span>
                                    </button>
                                </div>
                            </Menu>
                        </div>
                    </div>
                </div>

                <div className="mt-5 mb-5">
                    <DynamicTable
                        data={tableData}
                        isLoading={false}
                        columns={columns}
                        emptyMessage={t("noDataFound")}
                        showPagination={false}
                    />
                </div>
            </div>
            </div>
        </>
    );
}